'use client';
import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { forwardRef } from 'react';
import modules_cf3bd172 from './Card.module.scss.js';

const Card = forwardRef(({ appearance = "default", as, borderRadius = "l", children, "data-testid": testId, className, id, variant = "default", padding = "l", ...rest }, ref) => {
    const Component = as || "div";
    return (jsx(Component, { className: classnames(modules_cf3bd172.card, modules_cf3bd172[`appearance-${appearance}`], modules_cf3bd172[`borderRadius-${borderRadius}`], modules_cf3bd172[`padding-${padding}`], modules_cf3bd172[variant], className), "data-testid": testId, id: id, ref: ref, ...rest, children: children }));
});

export { Card };
//# sourceMappingURL=Card.js.map
